module.exports = __webpack_public_path__ + "static/img/illu_de_05.8b11b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_de_05.png
// module id = odB6
// module chunks = 1